// extracted by mini-css-extract-plugin
export var pageContainer = "_h-1";
export var settingsContent = "_h-0";